import React from 'react';
import {useTranslation} from 'react-i18next';
import {useRulesStore} from '../rules.store';
import SectionWrapper from './section-wrapper';
import DataTable from './data-table';

const StarRatingRequirements: React.FC = () => {
  const {t} = useTranslation();
  const {starRatingRequirements} = useRulesStore();

  // 星级要求表格列配置（国际化表头 + 新数据键）
  const columns = [
    {
      key: 'clubStars',
      title: t('agent.rules.tableHeaders.clubStars'),
    },
    {
      key: 'agentRequirements',
      title: t('agent.rules.tableHeaders.agentRequirements'),
    },
    {
      key: 'rechargeRequired',
      title: t('agent.rules.tableHeaders.rechargeRequired'),
    },
  ];

  return (
    <SectionWrapper title={t('agent.rules.starRatingRequirements.title')}>
      {/* 星级要求表格 */}
      <DataTable columns={columns} data={starRatingRequirements} />
    </SectionWrapper>
  );
};

export default StarRatingRequirements;
